module.exports = __webpack_public_path__ + "img/activeGoodsRecommendIcon.f43faff0.svg";